module.exports = __webpack_public_path__ + "assets/img/2ff3871fedd945ed199277f56a54810c.svg";